import { render } from "./pdf-viewer.vue?vue&type=template&id=57e48d7d"
import script from "./pdf-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-viewer.vue?vue&type=script&lang=js"

import "./pdf-viewer.vue?vue&type=style&index=0&id=57e48d7d&lang=less"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__